import { axios } from '@/common/api.service.js'

console.log('HERE AuthJS')

function emptyUserProfile() {
  return {
    id: 0,
    email: '',
    user_name: '',
    first_name: '',
    last_name: '',
    avatar_image: '',
  }
}

function normalizeUserProfile(payload = {}) {
  return {
    id: payload.id || payload.email || 0,
    email: payload.email || '',
    user_name: payload.user_name || '',
    first_name: payload.first_name || '',
    last_name: payload.last_name || '',
    avatar_image: payload.avatar_image || '',
  }
}

const state = () => ({
  isAuthenticated: false,
  authResolved: false,
  isRegisterOpen: false,
  signupMode: 'open',
  current_view: '',
  registerStatus: '',
  pageTitle: '',
  message: '',
  csrf_token: '',
  refresh_token: '',
  access_token: '',
  userProfile: emptyUserProfile(),
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  imgHeaders: {
    'Content-Type': 'multipart/form-data',
  },
})
//---------------
// getters
//---------------
const getters = {
  getPageTitle(state) {
    return state.pageTitle
  },
  isAuthenticated(state) {
    return state.isAuthenticated
  },
  isRegisterOpen(state) {
    if (state.isRegisterOpen) {
      return true
    } else {
      return false
    }
  },
  getRegisterStatus(state) {
    return state.registerStatus
  },
  getSignupMode(state) {
    return state.signupMode
  },
  getCurrentView(state) {
    return state.current_view
  },
  getMessage(state) {
    return state.message
  },
  getCsrfToken(state) {
    return state.csrf_token
  },
  getHeaders(state) {
    return state.headers
  },
  getImgHeaders(state) {
    return state.imgHeaders
  },
  getUserProfile(state) {
    return state.userProfile
  },
}

const actions = {
  storeCsrfToken({ commit }, payload) {
    commit('setCsrfToken', payload)
  },
  storeMessage({ commit }, payload) {
    commit('setMessage', payload)
  },
  async ensureAuthState({ state, dispatch }) {
    if (state.authResolved) {
      return state.isAuthenticated
    }

    return dispatch('bootstrapAuth')
  },
  async bootstrapAuth({ commit, state }) {
    const endpoint = 'api/v1/dj-rest-auth/user/'
    const headers = state.headers

    try {
      const response = await axios.get(endpoint, {
        headers: headers,
        mode: 'same-origin',
      })

      if (response && response.data) {
        commit('setUserProfile', response.data)
        return true
      }
    } catch (err) {
      const status = err?.response?.status

      if (status === 401 || status === 403) {
        commit('destroyToken')
        commit('destroyUserProfile')
        return false
      }

      commit('destroyToken')
      commit('destroyUserProfile')
      return false
    }

    commit('destroyToken')
    commit('destroyUserProfile')
    return false
  },
  async verifyRegisterOpen({ commit, state }) {
    const endpoint = 'api/v1/dj-rest-auth/registration/verify/'
    const headers = state.headers
    await axios
      .get(endpoint, {
        headers: headers,
        mode: 'same-origin',
      })
      //----------------------
      // where api ok
      //----------------------
      .then((response) => {
        commit('setRegisterStatus', response.data)
      })
      //----------------------
      // where api error
      //----------------------
      .catch((err) => {
        throw window.getErrorMessage(err)
      })
  },
  async registerUser({ commit, state }, payload) {
    const endpoint = 'api/v1/dj-rest-auth/registration/'
    const headers = state.headers
    const response = await axios
      .post(endpoint, payload, {
        headers: headers,
        mode: 'same-origin',
      })
      //----------------------
      // where api error
      //----------------------
      .catch((err) => {
        commit('destroyToken')
        commit('destroyUserProfile')
        throw window.getErrorMessage(err)
      })
    //----------------------
    // where api ok
    //----------------------
    if (response && response.data) {
      return response.data
    }

    return null
  },
  async userLogin({ commit, dispatch, state }, payload) {
    const endpoint = 'api/v1/dj-rest-auth/login/'
    const headers = state.headers

    const response = await axios
      .post(endpoint, payload, {
        headers: headers,
        mode: 'same-origin',
      })
      //----------------------
      // where api error
      //----------------------
      .catch((err) => {
        console.log('userLogin - error =', err)
        commit('destroyToken')
        commit('destroyUserProfile')
        throw window.getErrorMessage(err)
      })

    if (response && response.data) {
      if (response.data.user) {
        commit('setUserProfile', response.data.user)
      } else {
        await dispatch('bootstrapAuth')
      }

      return response.data
    }

    return null
  },
  async resendEmail({ state }, payload) {
    const endpoint = 'api/v1/dj-rest-auth/registration/resend-email/'
    const headers = state.headers
    const response = await axios
      .post(endpoint, payload, {
        headers: headers,
        mode: 'same-origin',
      })
      //----------------------
      // where api error
      //----------------------
      .catch((err) => {
        throw window.getErrorMessage(err)
      })
    //----------------------
    // where api ok
    //----------------------
    if (response && response.data) {
      return response.data
    }

    return null
  },
  async sendPasswordResetEmail({ state }, payload) {
    const endpoint = 'api/v1/dj-rest-auth/password/reset/'
    const headers = state.headers
    const response = await axios
      .post(endpoint, payload, {
        headers: headers,
        mode: 'same-origin',
      })
      //----------------------
      // where api error
      //----------------------
      .catch((err) => {
        throw window.getErrorMessage(err)
      })
    //----------------------
    // where api ok
    //----------------------
    if (response && response.data) {
      return response.data
    }

    return null
  },
  async userLogout({ commit, state }) {
    const endpoint = 'api/v1/dj-rest-auth/logout/'
    const headers = state.headers
    const response = await axios
      .post(endpoint, null, {
        headers: headers,
        mode: 'same-origin',
      })
      .catch((err) => {
        const status = err?.response?.status

        if (status === 401 || status === 403) {
          commit('destroyToken')
          commit('destroyUserProfile')
          return null
        }

        throw window.getErrorMessage(err)
      })

    commit('destroyToken')
    commit('destroyUserProfile')
    return response?.data ?? null
  },
  async readUserProfile({ commit, state }, { payload } = {}) {
    const endpoint = 'api/v1/dj-rest-auth/user/'
    const headers = state.headers
    const response = await axios({
      method: 'get',
      url: endpoint,
      headers: headers,
      params: payload,
    })
      //-----------------=
      // where api error
      //-----------------
      .catch((err) => {
        throw window.getErrorMessage(err)
      })
    //----------------------
    // where successful
    //----------------------
    if (response && response.data) {
      commit('setUserProfile', response.data)
      return response.data
    }

    return null
  },
  async editUserProfile({ commit, state }, { payload }) {
    const endpoint = 'api/v1/dj-rest-auth/user/'
    const headers = state.headers
    const response = await axios
      .patch(endpoint, payload, {
        headers: headers,
        mode: 'same-origin',
      })
      //----------------------
      // where api error
      //----------------------
      .catch((err) => {
        throw window.getErrorMessage(err)
      })
    //----------------------
    // where successful
    //----------------------
    if (response && response.data) {
      commit('setUserProfile', response.data)
      return response.data
    }

    return null
  },
  async changeAvatar({ commit }, { avatar_file }) {
    const endpoint = 'api/v1/user/avatar/'

    const this_headers = {
      'content-type': 'multipart/form-data',
    }

    const response = await axios
      .patch(endpoint, avatar_file, {
        headers: this_headers,
        mode: 'same-origin',
      })
      //----------------------
      // where api error
      //----------------------
      .catch((err) => {
        throw window.getErrorMessage(err)
      })
    //----------------------
    // where successful
    //----------------------
    if (response && response.data) {
      commit('setAvatar', response.data)
      return response.data
    }

    return null
  },
  async changePassword({ commit, state }, { payload }) {
    const endpoint = 'api/v1/dj-rest-auth/password/change/'
    const headers = state.headers
    const response = await axios
      .post(endpoint, payload, {
        headers: headers,
        mode: 'same-origin',
      })
      //----------------------
      // where api error
      //----------------------
      .catch((err) => {
        throw window.getErrorMessage(err)
      })
    //----------------------
    // where successful
    //----------------------
    if (response && response.data) {
      commit('destroyToken')
      commit('destroyUserProfile')
      return response.data
    }

    commit('destroyToken')
    commit('destroyUserProfile')
    return null
  },
  async resetPassword({ state }, { payload }) {
    const endpoint = '/api/v1/dj-rest-auth/password/reset/confirm/'
    const headers = state.headers
    const response = await axios
      .post(endpoint, payload, {
        headers: headers,
        mode: 'same-origin',
      })
      //----------------------
      // where api error
      //----------------------
      .catch((err) => {
        throw window.getErrorMessage(err)
      })
    //----------------------
    // where successful
    //----------------------
    if (response && response.data) {
      return response.data
    }

    return null
  },
}

const mutations = {
  setPageTitle(state, payload) {
    state.pageTitle = payload
  },
  setRegisterStatus(state, payload) {
    state.isRegisterOpen = payload['registerStatus']
    state.signupMode = payload['signupMode'] || 'open'
    state.registerStatus = payload['message']
  },
  setMessage(state, payload) {
    state.message = payload
  },
  setCurrentView(state, payload) {
    state.current_view = payload
  },
  setAuthResolved(state, payload) {
    state.authResolved = payload
  },
  destroyMessage(state) {
    state.message = null
  },
  setCsrfToken(state, payload) {
    state.csrf_token = payload
  },
  destroyToken(state) {
    state.isAuthenticated = false
    state.authResolved = true
    state.access_token = null
    state.refresh_token = null
  },
  setUserProfile(state, payload) {
    state.userProfile = normalizeUserProfile(payload)
    state.isAuthenticated = true
    state.authResolved = true
  },
  setAvatar(state, payload) {
    state.userProfile = {
      ...normalizeUserProfile(state.userProfile),
      avatar_image: payload.avatar_image || '',
    }
  },
  destroyUserProfile(state) {
    state.userProfile = emptyUserProfile()
    state.isAuthenticated = false
    state.authResolved = true
  },
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
